import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toggleSidebar, hidePermissionDenied } from "./actions/app";
import { initializeAuth } from "./actions/auth";
import Service from "./pages/Server/Service/Service";
import ClientSideApp from "./pages/Client/ClientSideApp";
import HomePage from "./pages/Home";
import MyProjects from './pages/Projects/MyProjects';
import ProjectDetails from './pages/Projects/ProjectDetails';
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Callback from "./pages/Callback";
import UserList from "./pages/Users/UserList";
import UserPermissions from "./pages/Users/UserPermissions";
import PermissionDeniedModal from "./components/Modals/PermissionDeniedModal";
import BatchJob from "./pages/BatchJob/BatchJob";
import MyResources from "./pages/Resources/MyResources";
import DatabasePage from "./pages/Database/Database";
import AlarmsPage from "./pages/Alarms/alarms";


const App = () => {
  const dispatch = useDispatch();
  const { isSidebarOpen, permissionDeniedModal } = useSelector((state) => state.app);
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);
  
  return (
    <div className="flex min-h-screen">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <div className="flex w-full">
                  <Sidebar isOpen={isSidebarOpen} toggleSidebar={handleToggleSidebar} />
                  <div className={`flex-grow overflow-y-auto transition-all duration-300 ease-in-out ${isSidebarOpen ? 'ml-64' : 'ml-16'}`}>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/projects" element={<MyProjects />} />
                      <Route path="/project/:projectId" element={<ProjectDetails />} />
                      <Route path="/project/:projectId/frontend-app/:appId" element={<ClientSideApp/>} />
                      <Route path="/project/:projectId/backend-service/:serviceId" element={<Service/>} />
                      <Route path="/batch-jobs" element={<BatchJob/>} />
                      <Route path="/users" element={<UserList/>} />
                      <Route path="/users/:userId/permissions" element={<UserPermissions />} />
                      <Route path="/resources" element={<MyResources />} />
                      <Route path="/project/:projectId/database/:databaseId" element={<DatabasePage />} />
                      <Route path="/alarms" element={<AlarmsPage />} />
                    </Routes>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <PermissionDeniedModal
        visible={permissionDeniedModal.visible}
        onClose={() => dispatch(hidePermissionDenied())}
      />
    </div>
  );
}

export default App;
